import { isDefined } from '@sgme/fp';
import { useEffect, useState } from 'react';
import type { TrackedValue } from 'state/secondaryMarket/realtime/realtime.model';
export type TrendMap = { decrease?: string; increase?: string; stagnate?: string; reset?: string };

const defaultTrendMap: TrendMap = {
  decrease: 'bg-danger bg-opacity-40',
  increase: 'bg-success bg-opacity-40',
  reset: 'text-primary',
  stagnate: 'text-primary',
};
export const useTrend = (trackedValue?: TrackedValue, trendMap = defaultTrendMap, tickDelay = 500) => {
  const [mappedValue, setMappedValue] = useState<string>();
  useEffect(() => {
    const timeout = setTimeout(() => {
      setMappedValue(trendMap.reset);
    }, tickDelay);
    if (isDefined(trackedValue?.trend)) {
      setMappedValue(trendMap[trackedValue.trend]);
    }
    return () => clearTimeout(timeout);
  }, [trackedValue, trendMap, tickDelay]);
  return mappedValue;
};
